import { render, staticRenderFns } from "./infotarget.vue?vue&type=template&id=0910df7a&scoped=true&"
import script from "./infotarget.vue?vue&type=script&lang=js&"
export * from "./infotarget.vue?vue&type=script&lang=js&"
import style0 from "./infotarget.vue?vue&type=style&index=0&id=0910df7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0910df7a",
  null
  
)

export default component.exports